import { NgIf, NgTemplateOutlet } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';

export interface IframeDialogData {
  url: string;
  title: string;
  doRetry?: false;
  isImage?: boolean;
  validateMode?: boolean;
}

@Component({
  selector: 'app-iframe-dialog',
  templateUrl: './iframe-dialog.component.html',
  styleUrls: ['./iframe-dialog.component.scss'],
  standalone: true,
  imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule, NgIf, MatProgressSpinnerModule]
})
export class IframeDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('iframe', { static: false }) iframe: HTMLIFrameElement;
  dialogTitle: string;
  docUrl: SafeUrl;

  readonly MAX_LOADING_TRIES = 5;
  readonly LOADING_TIMEOUT = 2500;

  iFrameLoaded = false;
  iFrameError = false;
  iFrameClass = '';
  loadTries = 1;
  timer;

  constructor(
    public dialogRef: MatDialogRef<IframeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IframeDialogData,
    private domSanitizer: DomSanitizer
  ) {
    this.dialogTitle = data.title;
    this.docUrl = this.getDocUrl();
    this.dialogRef.updateSize('95vw');

    if (!this.data.isImage && this.data.doRetry) {
      this.iFrameClass = 'hidden';
      this.timer = setInterval(() => this.tryLoadIframe(), this.LOADING_TIMEOUT);
    }
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {}

  getDocUrl(): SafeUrl {
    return this.domSanitizer.bypassSecurityTrustResourceUrl(this.data.url);
  }

  onLoadIframe(event: any) {
    // browsers tips :
    // - Firefox triggers this event only when the iframe successfully loads
    // - Google and Safari always trigger this event twice, when it first loads with "about:blank (empty html body)" then when it loads successfully
    // For Same Domain Iframe contentDocument is not null so we check the body child element
    // For Google Docs, the iframe url is external so the contentDocument is always null (security reasons)
    // Google Docs Error case : sometimes it returns a 204 with no content when trying to load
    // So it succeeds when the event is triggered and there is no contentDocument (externalUrl) or if we have div elements
    // Bug Safari: sometimes the 204 error from google docs is view as a success and an empty view is shown
    if (!event.srcElement.contentDocument || event.srcElement.contentDocument.querySelector('div')) {
      this.iFrameClass = '';
      this.iFrameLoaded = true;
      this.stopLoadingTry();
    }
  }

  tryLoadIframe() {
    if (this.iFrameLoaded) return;
    if (this.loadTries < this.MAX_LOADING_TRIES) {
      //reload iframe
      this.docUrl = null;
      this.docUrl = this.getDocUrl();
      this.loadTries++;
    } else {
      // loading error
      this.iFrameError = true;
      this.iFrameClass = 'hidden';
      //stop trying loading
      this.stopLoadingTry();
    }
  }

  stopLoadingTry() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  docValidated() {
    this.dialogRef.close(true);
  }
}
